var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUiCloseXbold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.64 10.79L36.772 8 24 21.131 11.228 8 8.36 10.79 21.21 24 8.36 37.21 11.228 40 24 26.869 36.772 40l2.868-2.79L26.79 24l12.85-13.21z"
  })));
}
export default SvgIconUiCloseXbold;